<fieldset>
    <legend>Dit item maakt deel uit van een serie. Wat wil je:</legend>
    <mat-radio-group class="example-radio-group" [(ngModel)]="rbKeuze">
        <mat-radio-button class="example-radio-button" value="1">Bekijk of bewerk alleen van vandaag</mat-radio-button>
        <mat-radio-button class="example-radio-button" value="2">Bekijk of bewerk de hele serie afspraken vanaf vandaag</mat-radio-button>
    </mat-radio-group>
    <div style = "margin-left:10px;color:red;" *ngIf="rbKeuze == 0">
        Kies een keuze uit!
    </div>
    <div>
        <button mat-raised-button style = "margin:10px;" (click) = "btnNext()" color="accent">Ok</button>
        <button mat-raised-button style = "margin:10px;"  (click) = "btnCancel()" color="accent">Cancel</button>
    </div>
</fieldset>